const prefix = 'cvf-admin/users/';

export const GET_USERS = `${prefix}GET_USERS`;
export const GET_USERS_SUCCESS = `${prefix}GET_USERS_SUCCESS`;
export const GET_USERS_ERROR = `${prefix}GET_USERS_ERROR`;

export const ADD_USER = `${prefix}ADD_USER`;
export const ADD_USER_SUCCESS = `${prefix}ADD_USER_SUCCESS`;
export const ADD_USER_ERROR = `${prefix}ADD_USER_ERROR`;

export const REMOVE_USERS = `${prefix}REMOVE_USERS`;
export const REMOVE_USERS_SUCCESS = `${prefix}REMOVE_USERS_SUCCESS`;
export const REMOVE_USERS_ERROR = `${prefix}REMOVE_USERS_ERROR`;

export const RESET_USERS = `${prefix}RESET_USERS`;
export const RESET_USERS_SUCCESS = `${prefix}RESET_USERS_SUCCESS`;
export const RESET_USERS_ERROR = `${prefix}RESET_USERS_ERROR`;
